{
  "version": 1,
  "asset_id": "b9562a55-7615-45fe-9f90-8893bb53c51a",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/b9562a55-7615-45fe-9f90-8893bb53c51a/mark-256.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/b9562a55-7615-45fe-9f90-8893bb53c51a/mark-256.avif",
  "original_filename": "mark-256.avif",
  "size": 6971,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:21Z"
}
